

function NoMatch() {
	return (
		<div style={{height: "100vh", backgroundColor: "var(--light-cream-color)"}}>
			<p style={{textAlign: "center", fontWeight: "500", paddingTop: "100px", fontSize: "1.2rem"}}>Página no existe</p>
		</div>
	)
}

export default NoMatch;